import { Button, Box, Dialog, Stack, Typography } from "@mui/material";
import { useState } from "react";

export default function DeleteConfirmation({handleDelete, title, ctaText, cancelCtaText, ctaColor, children}) {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);

  const handleClose = () => setOpen(false);

  const onDelete = (e) => {
    setOpen(false);
    handleDelete(e);
  };

  return (
    <Stack>
      <Box onClick={handleOpen}>
        {children}
      </Box>
      <Dialog open={open} onClose={handleClose}>
        <Stack px={10} py={4}>
          <Stack mb={4}>
            <Typography variant="h6">
              {title || "Are you sure you want to delete?"}
            </Typography>
          </Stack>
          <Stack gap={2} px={2}>
            <Button variant="contained" color={ctaColor || "error"} onClick={onDelete}>
              {ctaText || "Delete"}
            </Button>
            <Button onClick={handleClose}>
              {cancelCtaText || "Cancel"}
            </Button>
          </Stack>
        </Stack>
      </Dialog>
    </Stack>
  );
}